import { ClassData } from "../../../common/dtos/classes.type";
import RYBConnectClasses from "../../../common/services/classes.service";
import { DEFAULT_CATEGORY } from "../../../common/services/default-category.service";
import {
  RYB_CLASSES_DATA,
  URL_PARAMETERS,
} from "../../../common/utils/const.util";
import {
  filterByAge,
  filterByKeyAndValue,
} from "../../../common/utils/filters.util";
import { getUniqueLocationsList } from "../../../common/utils/locations.util";
import {
  getAllParamsFromURL,
  getUrlParameterValue,
  modifyUrlParameter,
} from "../../../common/utils/url.util";
import { setResultGridView } from "./result-grid.view";
import { saveFiltersToCookie } from "../../../common/utils/filter-cookie.util";

export function setFilterTopView() {
  if (ryb_connect_classes_data.wizard.steps["2"].length) {
    hideOldFields();
    setNewFields();
  }

  updateDropdownValuesFromURL();

  if ($(".edit-option.locations .dropdown.locations")) {
    setLocationsDropdownList();
    // ugly hack but no time
    // caused due to the race condition when setting elements
    setTimeout(() => {
      editBoxFunctionality();
    }, 1000);
    setClassTypeEditList();
  } else {
    setClassTypeEditList();
    editBoxFunctionality();
  }

  bindDesktopCalendarWheelForwarding();

  $(window)
    .off(`resize${DESKTOP_CALENDAR_WHEEL_EVENT_NS}`)
    .on(`resize${DESKTOP_CALENDAR_WHEEL_EVENT_NS}`, function () {
      bindDesktopCalendarWheelForwarding();
    });
}

function hideOldFields() {
  const wrapper = document.querySelector("#class-finder .filter-top");
  if (wrapper) {
    const locations = wrapper.querySelector(".edit-option.locations");
    if (locations) {
      locations.remove();
    }
    const age = wrapper.querySelector(".edit-option.age");
    if (age) {
      age.remove();
    }
    const gender = wrapper.querySelector(".edit-option.gender");
    if (gender) {
      gender.remove();
    }
  }
}

function setNewFields() {
  const wrapper = document.querySelector(
    "#class-finder .filter-top .filter-controls"
  );

  if (wrapper) {
    ryb_connect_classes_data.wizard.steps["2"].forEach((item) => {
      const logoDiv = document.createElement("div");
      logoDiv.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.5652 1.6709C11.9773 1.6709 11.3897 1.89335 10.9449 2.33822L4.27658 9.00651C3.96835 9.31474 3.75419 9.70497 3.65972 10.1304L2.09803 17.1559C2.07509 17.2587 2.07847 17.3655 2.10785 17.4666C2.13722 17.5677 2.19165 17.6597 2.26608 17.7341C2.34052 17.8086 2.43254 17.863 2.53362 17.8924C2.6347 17.9217 2.74156 17.9251 2.84429 17.9022L9.86984 16.3405C10.2952 16.246 10.6855 16.0327 10.9937 15.7244L17.6628 9.05534C18.552 8.16554 18.5516 6.70438 17.662 5.81478L14.1854 2.33822C13.7406 1.89335 13.153 1.6709 12.5652 1.6709ZM5.26535 9.78532C5.42932 9.87718 5.58058 9.98662 5.71375 10.1198C6.16167 10.5681 6.31185 11.1242 6.34852 11.5692C6.79352 11.6063 7.34875 11.7552 7.79709 12.2031C8.245 12.6515 8.39519 13.2075 8.43185 13.6525C8.87685 13.6896 9.43209 13.8385 9.88042 14.2865C10.0132 14.4194 10.1229 14.5714 10.2149 14.7357L10.1099 14.8407C9.96981 14.9808 9.79261 15.0776 9.59885 15.1206L6.69439 15.766L4.23507 13.3066L4.88042 10.4014C4.92345 10.2076 5.02026 10.0304 5.16037 9.8903L5.26535 9.78532Z"/>
                          </svg>`;
      const dropdownDiv = document.createElement("div");
      dropdownDiv.className = `edit-option ${item.query_parameter}`;

      const labelWrapperDiv = document.createElement("div");
      const labelDiv = document.createElement("div");
      labelDiv.className = "label";
      labelDiv.innerText = item.label;
      const valueDiv = document.createElement("div");
      valueDiv.className = "value";
      valueDiv.textContent = "";
      const urlParameter = getUrlParameterValue(item.query_parameter);
      if (urlParameter) {
        valueDiv.textContent =
          item.options.find((option) => option.option_value === urlParameter)
            ?.option_label || "";
      } else {
        valueDiv.innerText =
          item.options.find((option) => option.is_default === "1")
            ?.option_label || "";
      }
      const dropdownOptionsDiv = document.createElement("div");
      dropdownOptionsDiv.className = `dropdown ${item.query_parameter}`;
      const dropdownOptionsUl = document.createElement("ul");

      item.options.forEach((option) => {
        const listOption = document.createElement("li");
        listOption.innerText = option.option_label;
        listOption.setAttribute(
          "value",
          option.option_value === "null" || option.option_value === ""
            ? ""
            : option.option_value
        );
        dropdownOptionsUl.appendChild(listOption);
      });
      dropdownOptionsDiv.appendChild(dropdownOptionsUl);
      labelWrapperDiv.appendChild(labelDiv);
      labelWrapperDiv.appendChild(valueDiv);
      dropdownDiv.appendChild(labelWrapperDiv);
      dropdownDiv.appendChild(logoDiv);
      dropdownDiv.appendChild(dropdownOptionsDiv);
      const classDiv = wrapper.querySelector(".edit-option.class");
      wrapper.insertBefore(dropdownDiv, classDiv);
    });
  }
}

function isMobileFilter() {
  return window.innerWidth <= 768;
}

const FILTER_DRAWER_EVENT_NS = ".rybFilterDrawer";
const DESKTOP_CALENDAR_WHEEL_EVENT_NS = ".rybDesktopCalendarWheel";

function bindDesktopCalendarWheelForwarding() {
  const $scrollContainer = $("#class-finder .grid-view .grid-results");
  const $wheelZones = $(
    [
      "#class-finder .result-content > .filter-top",
      "#class-finder .result-content > .session-toolbar",
      "#class-finder .result-content > .session-portal-banner",
    ].join(", ")
  );

  $wheelZones.off(`wheel${DESKTOP_CALENDAR_WHEEL_EVENT_NS}`);

  if (
    window.innerWidth < 1200 ||
    !$scrollContainer.length ||
    !$wheelZones.length
  ) {
    return;
  }

  const scrollNode = $scrollContainer.get(0);
  if (!scrollNode) {
    return;
  }

  $wheelZones.on(`wheel${DESKTOP_CALENDAR_WHEEL_EVENT_NS}`, function (event) {
    if ($(event.target as HTMLElement).closest(".dropdown:visible").length) {
      return;
    }

    const originalEvent = event.originalEvent as WheelEvent | undefined;
    if (!originalEvent) {
      return;
    }

    if (Math.abs(originalEvent.deltaY) < Math.abs(originalEvent.deltaX)) {
      return;
    }

    const maxScrollTop = scrollNode.scrollHeight - scrollNode.clientHeight;
    if (maxScrollTop <= 0) {
      return;
    }

    const nextScrollTop = Math.max(
      0,
      Math.min(maxScrollTop, scrollNode.scrollTop + originalEvent.deltaY)
    );

    if (nextScrollTop === scrollNode.scrollTop) {
      return;
    }

    scrollNode.scrollTop = nextScrollTop;
    event.preventDefault();
  });
}

function getOrCreateFilterDrawerOverlay() {
  let $overlay = $(".filter-drawer-overlay");
  if (!$overlay.length) {
    $("body").append('<div class="filter-drawer-overlay"></div>');
    $overlay = $(".filter-drawer-overlay");
  }
  return $overlay;
}

function closeDrawers() {
  $(".filter-top .edit-option").removeClass("active");
  $(".filter-drawer-overlay").removeClass("show");
  $("body").removeClass("ryb-filter-drawer-open");
}

function openDrawer($editOption: JQuery<HTMLElement>) {
  $(".filter-top .edit-option").removeClass("active");
  $editOption.addClass("active");
  getOrCreateFilterDrawerOverlay().addClass("show");
  $("body").addClass("ryb-filter-drawer-open");
}

function editBoxFunctionality() {
  const $overlay = getOrCreateFilterDrawerOverlay();
  $overlay.off(`click${FILTER_DRAWER_EVENT_NS}`).on(
    `click${FILTER_DRAWER_EVENT_NS}`,
    function (event) {
      event.stopPropagation();
      closeDrawers();
    }
  );

  $(".filter-top .edit-option")
    .off(`click${FILTER_DRAWER_EVENT_NS}`)
    .on(`click${FILTER_DRAWER_EVENT_NS}`, function (event) {
      event.stopPropagation();
      if ($(event.target as HTMLElement).closest(".dropdown").length) {
        return;
      }

      if (isMobileFilter()) {
        const $this = $(this);
        if ($this.hasClass("active")) {
          closeDrawers();
        } else {
          openDrawer($this);
        }
        return;
      }

      if ($(this).hasClass("active")) {
        $(".filter-top .edit-option").removeClass("active");
        return;
      }
      $(".filter-top .edit-option").removeClass("active");
      $(this).addClass("active");
    });

  $(".filter-top .edit-option .dropdown")
    .off(`click${FILTER_DRAWER_EVENT_NS}`)
    .on(`click${FILTER_DRAWER_EVENT_NS}`, function (event) {
      event.stopPropagation();
    });

  $(document)
    .off(`click${FILTER_DRAWER_EVENT_NS}`)
    .on(`click${FILTER_DRAWER_EVENT_NS}`, function () {
      closeDrawers();
    });

  $(".filter-top .edit-option:not(.class) .dropdown ul")
    .off(`click${FILTER_DRAWER_EVENT_NS}`, "li")
    .on(`click${FILTER_DRAWER_EVENT_NS}`, "li", function (event) {
      event.stopPropagation();
      const selectedText = $(this).text();
      const $editOption = $(this).closest(".edit-option");
      const classes = $editOption?.attr("class")?.split(" ");
      const className =
        classes?.find((cls) => cls !== "edit-option" && cls !== "active") ||
        "";
      const selectedValue = getDropdownOptionValue(
        $(this),
        className,
        selectedText
      );
      const $ul = $(this).closest("ul");
      $ul.find("li").removeClass("select");

      if (selectedValue) {
        $(this).addClass("select");
      }

      $editOption.find(".value").text(selectedText);

      setEventClicking(selectedValue, className);
      closeDrawers();
    });
}

function normalizeDropdownText(value: string | undefined) {
  return (value || "").trim().toLowerCase();
}

function getDropdownOptionValue(
  $item: JQuery<HTMLElement>,
  className: string,
  selectedText: string
) {
  const explicitValue = $item.attr("value") ?? $item.attr("data-value");
  if (explicitValue !== undefined) {
    return explicitValue;
  }

  const normalizedText = normalizeDropdownText(selectedText);
  if (!normalizedText || normalizedText === "all selected") {
    return "";
  }

  if (className === URL_PARAMETERS.GENDER) {
    return normalizedText;
  }

  // Keep human-readable age labels when value attributes are missing;
  // age filtering supports this fallback in filters.util.ts.
  if (className === URL_PARAMETERS.AGE) {
    return selectedText.trim();
  }

  return selectedText.trim();
}

function setEventClicking(value: string | undefined, className: string) {
  const classManager = new RYBConnectClasses();
  const key =
    !ryb_connect_classes_data.wizard.steps["2"].length &&
    className === "locations"
      ? URL_PARAMETERS.LOCATION
      : className;

  if (!key) {
    return;
  }

  const url = new URL(window.location.href);
  if (value) {
    url.searchParams.set(key, value);
  } else {
    url.searchParams.delete(key);
  }
  history.pushState({}, "", url);

  classManager
    .getFilteredDataByURLParams()
    .then((response) => {
      setResultGridView(response);
      setClassTypeEditList();
      saveFiltersToCookie();
    })
    .catch((_error) => {
      $("#ryb-openings-result").html(
        `<p class="display:block">Error: Unable to fetch class openings.</p>`
      );
    });
}

function getDropdownItemByParamValue(
  $dropdown: JQuery<HTMLElement>,
  paramValue: string
) {
  const $itemByValue = $dropdown.find(`li[value="${paramValue}"]`);
  if ($itemByValue.length) {
    return $itemByValue.first();
  }

  const normalizedParam = normalizeDropdownText(paramValue);
  return $dropdown
    .find("li")
    .filter(function () {
      const $item = $(this);
      const itemValue = normalizeDropdownText(
        $item.attr("value") ?? $item.attr("data-value")
      );
      const itemText = normalizeDropdownText($item.text());
      return itemValue === normalizedParam || itemText === normalizedParam;
    })
    .first();
}

export function setLocationsDropdownList() {
  const classManager = new RYBConnectClasses();
  classManager.getData().then((response) => {
    if (!response) return;

    const availableLocations = getUniqueLocationsList(response, "short");
    const locationSelect = document.querySelector(
      ".edit-option.locations .dropdown.locations ul"
    );

    availableLocations.forEach((location) => {
      const option = document.createElement("li");
      option.setAttribute("value", location.value); // Use data attribute instead
      option.textContent = location.label;

      locationSelect?.appendChild(option);
    });
  });
}

export function setClassTypeEditList() {
  const classManager = new RYBConnectClasses();

  classManager
    .getData()
    .then((response) => {
      if (!response) return;
      const filters = getAllParamsFromURL();
      if (!filters) {
        return response;
      }
      // clear unnecessary filters
      if (filters) {
        delete filters[URL_PARAMETERS.STEP];
        delete filters[URL_PARAMETERS.USER];
        delete filters[URL_PARAMETERS.CONTACT];
        delete filters[URL_PARAMETERS.FULL_CLASSES];
        delete filters[URL_PARAMETERS.CATEGORY];
      }
      let data = structuredClone(response) || [];
      for (const [key, value] of Object.entries(filters)) {
        if (key) {
          if (key === URL_PARAMETERS.AGE) {
            data = filterByAge(data);
          }
          if (key === URL_PARAMETERS.GENDER) {
            data = filterByKeyAndValue(data, key, value);
          }
        }
      }
      data.filter((item) => item.location !== "HAM"); // REALLY WRONG - FIX WHEN YOU HAVE TIME
      editListFunctionality(data);
      updateDropdownValuesFromURL();
    })
    .catch((_error) => {
      $("#ryb-openings-result").html(
        `<p class="display:block">Error: Unable to fetch class openings - set class type edit list.</p>`
      );
    });
}

export function editListFunctionality(response: ClassData[]) {
  const classManager = new RYBConnectClasses();

  const $dropdownContainer = $(".edit-option.class .dropdown.classes");
  let $ul = $("<ul>");
  $dropdownContainer.empty().append($ul);

  // Use admin-configured categories for grouping (if available),
  // falling back to Jackrabbit parent category field.
  const adminCategories = (RYB_CLASSES_DATA as any).categories || [];
  const hasAdminCategories = adminCategories.length > 0 &&
    RYB_CLASSES_DATA.classes?.some((c: any) => c.category_id);

  const parentCategoryKey: "category1" | "category2" | null =
    hasAdminCategories ? null
    : DEFAULT_CATEGORY === "category3" ? "category2"
    : DEFAULT_CATEGORY === "category2" ? "category1"
    : null;

  const urlParams = new URLSearchParams(window.location.search);
  const selectedCategories = urlParams.getAll("classtype")?.length
    ? urlParams.getAll("classtype")[0].split(",")
    : [];

  $ul.append($("<li>").attr("value", "").text("All selected"));

  // Build grouped structure
  const groups: { parent: string; parentOrder: number; children: { value: string; displayName: string; order: number }[] }[] = [];

  response.forEach((item) => {
    const childValue = item[DEFAULT_CATEGORY];
    const classData = RYB_CLASSES_DATA.classes?.find((c) => c.name === childValue);
    if ((classData as any)?.status === "Hide" || (classData as any)?.status === "Invite-only (unlisted)") return;

    // Determine group name: prefer admin category, fall back to Jackrabbit parent field
    let parentValue = "";
    let parentOrder = 0;
    if (hasAdminCategories && classData?.category_id) {
      const adminCat = adminCategories.find((cat: any) => cat.id === classData.category_id);
      parentValue = adminCat?.name || "";
      parentOrder = parseInt(adminCat?.order_number || "0", 10);
    } else if (parentCategoryKey) {
      parentValue = (item as any)[parentCategoryKey] || "";
    }

    let group = groups.find((g) => g.parent === parentValue);
    if (!group) {
      group = { parent: parentValue, parentOrder, children: [] };
      groups.push(group);
    }

    if (!group.children.find((c) => c.value === childValue)) {
      group.children.push({
        value: childValue,
        displayName: (classData as any)?.display_name || childValue || "",
        order: parseInt((classData as any)?.order_number || "0", 10),
      });
    }
  });

  // Sort children within each group, then sort groups by parent order or first child order
  groups.forEach((g) => g.children.sort((a, b) => a.order - b.order));
  if (hasAdminCategories) {
    groups.sort((a, b) => a.parentOrder - b.parentOrder);
  } else {
    groups.sort((a, b) => (a.children[0]?.order || 0) - (b.children[0]?.order || 0));
  }

  groups.forEach((group) => {
    if (group.children.length === 0) return;

    // Add group header from admin categories or Jackrabbit parent field
    if ((hasAdminCategories || parentCategoryKey) && group.parent) {
      $ul.append(
        $("<li>").addClass("dropdown-group-header").text(group.parent)
      );
    }

    group.children.forEach((child) => {
      const isChecked = selectedCategories.includes(child.value);
      const $li = $("<li>")
        .attr("value", child.value)
        .addClass("filterable-category")
        .html(`<label class="checkbox-label"><input type="checkbox" ${isChecked ? "checked" : ""} /><span class="checkbox-mark"></span><span class="checkbox-text">${child.displayName}</span></label>`);

      if (isChecked) {
        $li.addClass("select");
      }

      $ul.append($li);
    });
  });

  const refreshClassTypeResults = () => {
    classManager
      .getFilteredDataByURLParams()
      .then((response) => {
        setResultGridView(response);
        saveFiltersToCookie();
      })
      .catch((_error) => {
        $("#ryb-openings-result").html(
          `<p class="display:block">Error: Unable to fetch class openings - li something.</p>`
        );
      });
  };

  const applyClassTypeSelection = (
    $item: JQuery<HTMLElement>,
    isSelected: boolean
  ) => {
    const selectedValue = $item.attr("value") || "";
    const $checkbox = $item.find("input[type='checkbox']");
    if ($checkbox.length) {
      $checkbox.prop("checked", isSelected);
    }

    $item.toggleClass("select", isSelected);
    modifyUrlParameter(isSelected, selectedValue, URL_PARAMETERS.CATEGORY);

    const selectedItems = document.querySelectorAll(
      ".filter-top .edit-option.class li.select"
    );

    if (selectedValue) {
      if (selectedItems.length) {
        $item
          .closest(".dropdown.classes")
          .closest(".edit-option.class")
          .find(".value")
          .text(`${selectedItems.length} Selections`);
      } else {
        unsetClassTypeList(selectedItems, $item.get(0));
      }
    } else {
      unsetClassTypeList(selectedItems, $item.get(0));
    }

    refreshClassTypeResults();
  };

  $ul.on("click", "li:not(.dropdown-group-header)", function (e) {
    e.stopPropagation();
    const $item = $(this as HTMLElement);
    const selectedValue = $item.attr("value") || "";
    const $checkbox = $item.find("input[type='checkbox']");

    if (!selectedValue || !$checkbox.length) {
      e.preventDefault();
      const selectedItems = document.querySelectorAll(
        ".filter-top .edit-option.class li.select"
      );
      unsetClassTypeList(selectedItems, $item.get(0));
      refreshClassTypeResults();
      return;
    }

    // Keep checkbox interactions single-fired (label taps can emit multiple click targets).
    if (!$(e.target as HTMLElement).is("input[type='checkbox']")) {
      e.preventDefault();
      const nextChecked = !$checkbox.prop("checked");
      applyClassTypeSelection($item, nextChecked);
    }
  });

  $ul.on(
    "change",
    "li.filterable-category input[type='checkbox']",
    function (e) {
      e.stopPropagation();
      const $checkbox = $(this);
      const $item = $checkbox.closest("li");
      applyClassTypeSelection($item, $checkbox.prop("checked"));
    }
  );

  // Filter and update visible categories
  const visibleCategories = Array.from(
    new Set(response.map((item) => item[DEFAULT_CATEGORY]))
  );

  $ul.find(".filterable-category").each(function () {
    const categoryValue = $(this).attr("value") || "";

    // Hide or show based on current filtered response
    if (visibleCategories.includes(categoryValue)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  // Hide group headers with no visible children
  $ul.find(".dropdown-group-header").each(function () {
    const $header = $(this);
    const $children = $header.nextUntil(".dropdown-group-header");
    const hasVisible = $children.filter(".filterable-category:visible").length > 0;
    $header.toggle(hasVisible);
  });

  // Update dropdown text based on selected visible items
  const selectedItems = $ul.find("li.select:visible");
  if (selectedItems.length) {
    $(".edit-option.class .value").text(`${selectedItems.length} Selections`);
  } else {
    $(".edit-option.class .value").text("All selected");
  }
}

function unsetClassTypeList(selectedItems: NodeListOf<Element>, element: any) {
  selectedItems.forEach(function (item) {
    item.classList.remove("select");
  });
  $(".filter-top .edit-option.class li.filterable-category input[type='checkbox']").prop("checked", false);
  $(element)
    .closest(".dropdown.classes")
    .closest(".edit-option.class")
    .find(".value")
    .text(`All selected`);

  const url = new URL(window.location.href);
  url.searchParams.delete(URL_PARAMETERS.CATEGORY);
  history.pushState({}, "", url);
}

function updateDropdownValuesFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const genderParam = urlParams.get("gender");
  if (genderParam) {
    const $genderDropdown = $(".edit-option.gender .dropdown.gender ul");
    const $selectedGenderItem = getDropdownItemByParamValue(
      $genderDropdown,
      genderParam
    );

    if ($selectedGenderItem.length) {
      $genderDropdown.find("li").removeClass("select");
      $selectedGenderItem.addClass("select");
      $(".edit-option.gender .value").text($selectedGenderItem.text());
    }
  }

  const ageParam = urlParams.get("age");
  if (ageParam) {
    const $ageDropdown = $(".edit-option.age .dropdown.age ul");
    const $selectedAgeItem = getDropdownItemByParamValue(
      $ageDropdown,
      ageParam
    );

    if ($selectedAgeItem.length) {
      $ageDropdown.find("li").removeClass("select");
      $selectedAgeItem.addClass("select");
      $(".edit-option.age .value").text($selectedAgeItem.text());
    }
  }

  const locationsParam = urlParams.get("location");
  if (locationsParam) {
    const $locationDropdown = $(
      ".edit-option.locations .dropdown.locations ul"
    );
    const $selectedLocationItem = getDropdownItemByParamValue(
      $locationDropdown,
      locationsParam
    );

    if ($selectedLocationItem.length) {
      $locationDropdown.find("li").removeClass("select");
      $selectedLocationItem.addClass("select");
      $(".edit-option.locations .value").text($selectedLocationItem.text());
    }
  }
  const categoryParams = urlParams.getAll("classtype")?.length
    ? urlParams.getAll("classtype")[0].split(",")
    : [];

  const $classDropdown = $(".edit-option.class .dropdown.classes ul");
  $classDropdown.find("li.filterable-category").removeClass("select");
  $classDropdown
    .find("li.filterable-category input[type='checkbox']")
    .prop("checked", false);

  if (categoryParams.length) {
    categoryParams.forEach((category) => {
      const $selectedClassItem = $classDropdown.find(`li[value="${category}"]`);

      if ($selectedClassItem.length) {
        $selectedClassItem.addClass("select");
        $selectedClassItem
          .find("input[type='checkbox']")
          .prop("checked", true);
      }
    });

    $(".edit-option.class .value").text(`${categoryParams.length} Selections`);
  }
}
